// @flow @jsx h

import { h, Component } from 'preact'
import styles from './Sea.css'

export class Sea extends Component<{}, {}> {
  shouldComponentUpdate () {
    return false
  }
  render () {
    return (
      <div class={styles.sea}>
        <div class={styles.sea__waves} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Sea.js